import dkAxios from '@/jslib/dk-axios'

export const getBrandList = (data) => dkAxios({
  url: '/v1/cms/Brand',
  method: 'GET',
  params: data,
});

export const addBrand = data => dkAxios({
  url: '/v1/cms/Brand',
  method: 'POST',
  data,
})

export const editBrand = data => dkAxios({
  url: `/v1/cms/Brand/update`,
  method: 'POST',
  data,
})

export const getBrandDetail = data => dkAxios({
  url: `/v1/cms/Brand/getBrand?uuid=${data}`,
  method: 'GET',
})

export const deleteBrand = data => dkAxios({
  url: `/v1/cms/Brand/delete?uuid=${data}`,
  method: 'POST',
})

export const getBannerList = () => dkAxios({
  url: '/v1/cms/Banner',
  method: 'GET',
});

export const addBanner = data => dkAxios({
  url: '/v1/cms/Banner',
  method: 'POST',
  data,
})

export const editBanner = data => dkAxios({
  url: `/v1/cms/Banner/${data.uuid}`,
  method: 'PUT',
  data,
})

export const getBannerDetail = data => dkAxios({
  url: `/v1/cms/Banner/${data}`,
  method: 'GET',
})

export const deleteBanner = data => dkAxios({
  url: `/v1/cms/Banner/${data}`,
  method: 'DELETE',
})

export const getAbout = () => dkAxios({
  url: '/v1/cms/Config/about_us',
  method: 'GET',
})

export const addAbout = data => dkAxios({
  url: '/v1/cms/Config/about_us',
  method: 'PUT',
  data,
})

export const getJoinUs = () => dkAxios({
  url: '/v1/cms/Config/join_us',
  method: 'GET',
})

export const addJoinUs = data => dkAxios({
  url: '/v1/cms/Config/join_us',
  method: 'PUT',
  data,
})

export const getGVRP = () => dkAxios({
  url: '/v1/cms/Config/gvrp',
  method: 'GET',
})

export const addGVRP = data => dkAxios({
  url: '/v1/cms/Config/gvrp',
  method: 'PUT',
  data,
})

export const getCommonQuestionList = () => dkAxios({
  url: '/v1/cms/CommonQuestion',
  method: 'GET',
});

export const addCommonQuestion = data => dkAxios({
  url: '/v1/cms/CommonQuestion',
  method: 'POST',
  data,
})

export const editCommonQuestion = data => dkAxios({
  url: `/v1/cms/CommonQuestion/${data.uuid}`,
  method: 'PUT',
  data,
})

export const getCommonQuestionDetail = data => dkAxios({
  url: `/v1/cms/CommonQuestion/${data}`,
  method: 'GET',
})

export const deleteCommonQuestion = data => dkAxios({
  url: `/v1/cms/CommonQuestion/${data}`,
  method: 'DELETE',
})

export const getSearchKeyList = () => dkAxios({
  url: '/v1/cms/SearchKey',
  method: 'GET',
});

export const addSearchKey = data => dkAxios({
  url: '/v1/cms/SearchKey',
  method: 'POST',
  data,
})

export const editSearchKey = data => dkAxios({
  url: `/v1/cms/SearchKey/${data.uuid}`,
  method: 'PUT',
  data,
})

export const getSearchKeyDetail = data => dkAxios({
  url: `/v1/cms/SearchKey/${data}`,
  method: 'GET',
})

export const deleteSearchKey = data => dkAxios({
  url: `/v1/cms/SearchKey/${data}`,
  method: 'DELETE',
})


export const getConfig = data => dkAxios({
  url: '/v1/cms/Config/order_limit',
  method: 'GET',
  params: data,
})

export const getProtocol = data => dkAxios({
  url: '/v1/cms/Config/customer_protocol',
  method: 'GET',
  params: data,
})

export const getFlow = data => dkAxios({
  url: '/v1/cms/Config/offline_pay',
  method: 'GET',
  params: data,
})


export const setConfig = data => dkAxios({
  url: `/v1/cms/Config/${data.key}`,
  method: 'PUT',
  data,
})

export const getFeedbackList = data => dkAxios({
  url: '/v1/cms/Feedback',
  method: 'GET',
  params: data,
});

export const getFeedbackDetail = data => dkAxios({
  url: `/v1/cms/Feedback/${data}`,
  method: 'GET',
});

export const changeFeedback = data => dkAxios({
  url: `/v1/cms/Feedback/${data}`,
  method: 'PUT',
});

export const getCity = () => dkAxios({
  url: '/region.json',
  method: 'GET',
});

// 添加首页品牌、分类
export const BannerReadPage = () => dkAxios({
  url: `/v1/cms/Banner/readPage`,
  method: 'POST',
});

export const HomeBrandReadPage = () => dkAxios({
  url: `/v1/cms/HomeBrand/readPage`,
  method: 'POST',
});

export const getHomeBrandList = () => dkAxios({
  url: '/v1/cms/HomeBrand',
  method: 'GET',
});

export const addHomeBrand = data => dkAxios({
  url: '/v1/cms/HomeBrand',
  method: 'POST',
  data,
})

export const editHomeBrand = data => dkAxios({
  url: `/v1/cms/HomeBrand/${data.uuid}`,
  method: 'PUT',
  data,
})

export const getHomeBrandDetail = data => dkAxios({
  url: `/v1/cms/HomeBrand/${data}`,
  method: 'GET',
})

export const deleteHomeBrand = data => dkAxios({
  url: `/v1/cms/HomeBrand/${data}`,
  method: 'DELETE',
})

// =======
export const getHomeProductCategoryList = () => dkAxios({
  url: '/v1/cms/HomeProductCategory',
  method: 'GET',
});

export const addHomeProductCategory = data => dkAxios({
  url: '/v1/cms/HomeProductCategory',
  method: 'POST',
  data,
})

export const editHomeProductCategory = data => dkAxios({
  url: `/v1/cms/HomeProductCategory/${data.uuid}`,
  method: 'PUT',
  data,
})

export const getHomeProductCategoryDetail = data => dkAxios({
  url: `/v1/cms/HomeProductCategory/${data}`,
  method: 'GET',
})

export const deleteHomeProductCategory = data => dkAxios({
  url: `/v1/cms/HomeProductCategory/${data}`,
  method: 'DELETE',
})
// ======



// WEBPACK FOOTER //
// ./src/api/content.js